"use client";

import { AirStationMapItem } from "@/lib/types/air";
import React, { useEffect, useState } from "react";
import AirStationDrawer from "./AirStationDrawer";
import dynamic from "next/dynamic";

const AirStationMapDynamic = dynamic(() => import("./AirStationMap"), {
  ssr: false,
});

type Props = {
  stations: AirStationMapItem[];
};

const AirStationMapView: React.FC<Props> = ({ stations }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [selectedStationId, setSelectedStationId] = useState<string | null>(
    null,
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);
  return (
    <div className="h-[calc(100dvh-350px)] relative rounded-xl border border-border w-full">
      {isMounted && (
        <AirStationMapDynamic
          stations={stations}
          selectedStationId={isDrawerOpen ? selectedStationId : null}
          onStationSelect={(stationId) => {
            setIsDrawerOpen(true);
            setSelectedStationId(stationId);
          }}
        />
      )}
      {selectedStationId && (
        <AirStationDrawer
          isOpen={isDrawerOpen}
          setIsOpen={setIsDrawerOpen}
          stationId={selectedStationId}
        />
      )}
    </div>
  );
};

export default AirStationMapView;
